<template lang="html">
  <div id="company-page">

    <CompanyComponent></CompanyComponent>

    <section class="about-us-section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title">¿Porqué nosotros?</h2>
          </div>

          <div class="col-md-6 col-lg-3 col-info">
            <p class="mb-3 text-center">
              <img class="icon" src="public/images/pages/company/icon-1.svg">
            </p>
            <h5>ASESORES CAPACITADOS</h5>
            <p>
              Nuestro personal esta plenamente capacitado para asesorarle de manera oportuna sobre nuestros productos.
            </p>
          </div>

          <div class="col-md-6 col-lg-3 col-info">
            <p class="mb-3 text-center">
              <img class="icon" src="public/images/pages/company/icon-2.svg">
            </p>
            <h5>JUSTO A TIEMPO</h5>
            <p>
              Estamos comprometidos en tener a tiempo los productos que ofrecemos en el momento que el cliente los requiere.
            </p>
          </div>

          <div class="col-md-6 col-lg-3 col-info">
            <p class="mb-3 text-center">
              <img class="icon" src="public/images/pages/company/icon-3.svg">
            </p>
            <h5>GARANTIA</h5>
            <p>
              Todos nuestros productos están garantizados y les damos solución inmediata a los imprevistos.
            </p>
          </div>

          <div class="col-md-6 col-lg-3 col-info">
            <p class="mb-3 text-center">
              <img class="icon" src="public/images/pages/company/icon-4.svg">
            </p>
            <h5>GAMA DE PRODUCTOS</h5>
            <p>
              Nuestro principal objetivo es ofrecerle la gama de productos más amplia y actualizada del mercado de repuestos.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="vision-section">
      <div class="container oversized-container">
        <div class="box-plans">
          <!-- <h2 class="text-center title-2">Nosotros</h2> -->

          <!-- <p class="p-md text-center">
            xx
          </p> -->

          <div class="row row-plans">
            <div class="col-lg-6 col-xl-5 col-plan">
              <h6 class="title">Visión</h6>
              <p>
                Penetrar el mercado nacional por medios electrónicos para dar a conocer la gran variedad de productos automotrices e industriales que comercializamos.
              </p>
            </div>

            <div class="col-lg-6 col-xl-5 col-plan">
              <h6 class="title">Misión</h6>
              <p>
                Proveer productos de alta calidad dentro del ramo automotriz e industrial buscando siempre la innovación y lealtad de nuestros clientes, ofreciendo un servicio constante.
              </p>
            </div>

            <div class="col-12 col-plan">
              <h6 class="title">Valores</h6>

              <div class="row">
                <div class="col-md-6 col-lg-5 col-principle">
                  <p class="mb-3 text-center">
                    <img class="icon" src="public/images/pages/company/icon-b-1.svg">
                  </p>

                  <h6 class="princ-title">Excelencia</h6>
                  <p>
                    Estamos comprometidos en brindarles un servicio eficaz y de calidad a nuestros clientes.
                  </p>
                </div>

                <div class="col-md-6 col-lg-5 col-principle">
                  <p class="mb-3 text-center">
                    <img class="icon" src="public/images/pages/company/icon-b-2.svg">
                  </p>

                  <h6 class="princ-title">Responsabilidad</h6>
                  <p>
                    Ser constantes con el aprendizaje y crecimiento para brindarles un asesoría precisa.
                  </p>
                </div>

                <div class="col-md-6 col-lg-5 col-principle">
                  <p class="mb-3 text-center">
                    <img class="icon" src="public/images/pages/company/icon-b-3.svg">
                  </p>

                  <h6 class="princ-title">Respeto</h6>
                  <p>
                    Nos dirigimos siempre con educación a clientes, proveedores y compañeros dentro y fuera de la empresa.
                  </p>
                </div>

                <div class="col-md-6 col-lg-5 col-principle">
                  <p class="mb-3 text-center">
                    <img class="icon" src="public/images/pages/company/icon-b-4.svg">
                  </p>

                  <h6 class="princ-title">Proactividad</h6>
                  <p>
                    Actuamos de manera positiva ante cualquier problema que se presente, otorgando la solución mas efectiva.
                  </p>
                </div>

                <div class="col-md-6 col-lg-7 col-principle">
                  <p class="mb-2 text-center">
                    <img class="icon" src="public/images/pages/company/icon-b-5.svg">
                  </p>

                  <h6 class="princ-title">Trabajo en Equipo</h6>
                  <p>
                    La comunicación, empatía, aprendizaje e integración de nuestro personal es primordial para lograr nuestros objetivos organizacionales y satisfacer las necesidades de nuestros compradores.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import CompanyComponent from './company-component.vue';
export default {
  components: {
    CompanyComponent
  },
}
</script>
